import React from "react";

import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

import { MapContainer, Address } from "./GoogleMaps.styles";
import HTMLReactParser from "html-react-parser";

const GoogleMaps = (props) => {
  //PROPS
  const {
    latitude,
    longitude,
    google,
    address,
    linkMapsConcessionario
  } = props;
  //PROPS

  //DEFS
  console.log(latitude, longitude);
  //DEFS

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%"
  };

  return (
    <>
      <MapContainer>
        <Map
          containerStyle={containerStyle}
          google={google}
          initialCenter={{
            lat: Number(latitude),
            lng: -8.6120203
          }}
          zoom={15}
        >
          <Marker
            onClick={() => {
              window.open(linkMapsConcessionario, "_blank");
            }}
            name={"Motospazio"}
            position={{ lat: Number(latitude), lng: Number(longitude) }}
            icon={{
              url: "/images/marker.png",
              anchor: new google.maps.Point(113, 148),
              scaledSize: new google.maps.Size(113, 148)
            }}
          />
        </Map>
      </MapContainer>
      <Address href={linkMapsConcessionario} target="_blank">
        {address && HTMLReactParser(address)}
      </Address>
    </>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyCnYqH87jqT63C1XCk6_QA4zx1gdiylaWY"
})(GoogleMaps);
